import { fplIcon } from './fplIcon';
import { AudioWaveformIconLocal } from './AudioWaveformIcon';
import type { SvgComponent } from '@/types/SvgComponent';

/**
 * `icon.24.voice` artwork at 52x52.
 *
 * FPL ships this glyph at 24 only, and `fplIcon` drops caller `width`/`height`, so
 * `AudioWaveformIcon` cannot hold the 52px size the audio preview frames need. The 24 viewBox is
 * kept so the artwork scales rather than being cropped.
 *
 * Colour falls back to `currentColor` rather than `--color-icon`: the audio frames these render in
 * keep a hardcoded dark background under both flag states, and rely on inheriting the frame's own
 * white text colour.
 */
export const Voice52IconFpl: SvgComponent = (props) => {
  return (
    <svg width="52" height="52" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fill="var(--fpl-icon-color, currentColor)"
        d="M11.5 5a.5.5 0 0 1 .5.5v13a.5.5 0 0 1-1 0v-13a.5.5 0 0 1 .5-.5m3 1a.5.5 0 0 1 .5.5v11a.5.5 0 0 1-1 0v-11a.5.5 0 0 1 .5-.5m-6 2a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5m9 1a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-1 0v-5a.5.5 0 0 1 .5-.5m-12 1a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-1 0v-3a.5.5 0 0 1 .5-.5"
      />
    </svg>
  );
};

/**
 * Flag off renders the legacy `AudioWaveformIcon` artwork, whose own intrinsic size is already 52,
 * so callers need not pass a size. Flag on renders the FPL glyph at 52.
 */
export const Voice52Icon = fplIcon(AudioWaveformIconLocal, Voice52IconFpl);
